import React, {Component} from "react";
import {Switch, Route} from "react-router-dom";
import "./App.css";

import Home from "Home/Home";
import CaseStudy from "CaseStudy/CaseStudy";
import TicTacToe from "TicTacToe/TicTacToe";

export default class App extends Component
{
    render()
    {
        return (
            <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/cases/:project" component={CaseStudy} />
                <Route path="/tictactoe" component={TicTacToe} />
            </Switch>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/App/App.js